function setServiceTrips(data) {
	return {
		type: 'SET_SERVICE_TRIPS',
		payload: data,
	};
}

export { setServiceTrips };
